<template>
  <v-main class="auth-layout d-grid align-center login-layout bg-auth-background">
    <v-container fluid style="position: relative">
      <VBtn color="on-surface" icon @click="toggleTheme" style="position: absolute; top: 16px; right: 16px; z-index: 10">
        <VIcon>{{ isDark ? 'mdi-weather-sunny' : 'mdi-weather-night' }}</VIcon>
      </VBtn>
      <router-view />
    </v-container>
  </v-main>
</template>

<script setup>
import { useThemeConfig } from '@/composables/useThemeConfig';

// Theme toggle
const { theme } = useThemeConfig();

const isDark = computed(() => theme.value === 'dark');
function toggleTheme() {
  theme.value = isDark.value ? 'light' : 'dark';
}
</script>

<style lang="scss">
@use '@/styles/main.scss';
@use '@/styles/blank-view.scss';
</style>

<style scoped lang="scss">
.login-layout {
  background-position: center;
}
</style>
